import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Prompt, useParams } from 'react-router-dom';
import KioskBranch from './components/KioskBranch/KioskBranch';
import KioskId from './components/KioskId/KioskId';
import KioskIp from './components/KioskIp/KioskIp';
import KioskLanguage from './components/KioskLanguage/KioskLanguage';
import KioskPassword from './components/KioskPassword/KioskPassword';
import KioskPort from './components/KioskPort/KioskPort';
import KioskTerminalId from './components/KioskTerminalId/KioskTerminalId';
import kioskEditStore from './store/kioskEditStore';
import SettingControlsBlock from '~/view/screens/SettingsScreen/containers/SettingControlsBlock/SettingControlsBlock';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from '~/view/containers/Headers/Headers';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import { localeStore } from '~/mobx/localesStore';
import { SCREENS } from '~/constants/screens';
import './style.scss';
import KioskMultiplier from '~/view/screens/SettingsScreen/screens/Devices/screens/KioskEditScreen/components/KioskMultiplier/KioskMultiplier';

const KioskEditScreen: FC = observer((): JSX.Element => {
  const { id: kioskId } = useParams<{ id?: string }>();
  const headerTitle: string = localeStore.t(kioskId ? 'edit_kiosk' : 'create_new_kiosk');

  useEffect(() => {
    kioskEditStore.init(kioskId);
  }, []);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={headerTitle} path={SCREENS.SETTINGS_DEVICES_KIOSKS()} />
      </Headers>

      <div className="d-flex flex-column gap-15 mt-6 mb-8">
        {kioskId ? <KioskId /> : null}
        <KioskLanguage />
        <KioskPassword />
        <KioskBranch />
        <KioskTerminalId />
        <KioskIp />
        <KioskPort />
        <KioskMultiplier />
      </div>

      <SettingControlsBlock
        redirectPath={SCREENS.SETTINGS_DEVICES_KIOSKS()}
        setValidation={kioskEditStore.validateBeforeSave}
        onSubmit={kioskEditStore.onSubmit}
      />

      <LoadingOverlay visible={kioskEditStore.isLoading} />
      <Prompt when={kioskEditStore.isDataEdited} message={getPromptProps()} />
    </div>
  );
});

export default KioskEditScreen;
